// extracted by mini-css-extract-plugin
export var alternate = "_15-j";
export var black = "_15-6";
export var blue = "_15-f";
export var blueLight = "_15-e";
export var brand = "_15-8";
export var darkMode = "_15-b";
export var error = "_15-a";
export var gray = "_15-5";
export var grayBlue = "_15-d";
export var iconWrapper = "_15-3";
export var inactive = "_15-7";
export var indigo = "_15-g";
export var orange = "_15-i";
export var pink = "_15-h";
export var primary = "_15-0";
export var purple = "_15-9";
export var success = "_15-4";
export var warning = "_15-c";
export var white = "_15-1";
export var whiteSuccess = "_15-2";